/*
 * topical-prescription (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { topicalPrescriptions } from "./topical-prescription.schema"

/* Select */
export type TopicalPrescription = z.infer<typeof selectTopicalPrescriptionSchema>
export const selectTopicalPrescriptionSchema = createSelectSchema(topicalPrescriptions)

/* Filters */
export type TopicalPrescriptionFilters = z.infer<typeof topicalPrescriptionFiltersSchema>
export const topicalPrescriptionFiltersSchema = z.object({
	id:             z.string().optional(),
	patientId:      z.string().optional(),
	practitionerId: z.string().optional(),
	producerId:     z.string().optional(),
	active:         z.boolean().optional(),
})

/* Create */
export const createTopicalPrescriptionSchema = createInsertSchema(topicalPrescriptions)
	.partial(globalCreateExclude)
export type CreateTopicalPrescription = z.infer<typeof createTopicalPrescriptionSchema>

/* Update */
export const updateTopicalPrescriptionSchema = createInsertSchema(topicalPrescriptions)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateTopicalPrescription = z.infer<typeof updateTopicalPrescriptionSchema>
